module.exports = __webpack_public_path__ + "assets/9fa1a2d0a670ce5764688b35b1a10a79.png";